// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { renderToString } from 'react-dom/server';
import { RouterContext, match } from 'react-router';
import { Provider } from 'react-redux';

import createRoutes from './routes';
import configureStore from './configureStore';
import inBrowser from './utils/inBrowser';
import './index.css';

if (inBrowser()) {
  const root = document.getElementById('root');
  const initialState = JSON.parse(atob(root.dataset.initialState));
  const store = configureStore(initialState);

  delete root.dataset.initialState;

  ReactDOM.render((
    <Provider store={store}>
      {createRoutes(store)}
    </Provider>
  ), root);
}

export default function render(
  path: string,
  props: Object = {}
): Promise<string> {
  return new Promise((resolve, reject) => {
    const store = configureStore(props);
    const routes = createRoutes(store);

    match({
      routes,
      location: path
    }, (err, redirect, renderProps) => {
      if (err || !renderProps) {
        reject(err);
        return;
      }

      resolve(renderToString(
        <Provider store={store}>
          <RouterContext {...renderProps} />
        </Provider>
      ));
    });
  });
}



// WEBPACK FOOTER //
// ./src/index.jsx